import React from 'react'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'

// Page title row. `back` is a path to return to; `eyebrow` is the small
// label above the title (e.g. the section name); `actions` sit on the right.
const PageHeader = ({ eyebrow, title, subtitle, back, actions, children }) => {
  const navigate = useNavigate()
  return (
    <Stack gap={1.5}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'flex-start' }}
        gap={1.5}
      >
        <Stack direction="row" gap={1} alignItems="flex-start" minWidth={0}>
          {back && (
            <IconButton
              size="small"
              onClick={() => navigate(back)}
              aria-label="Back"
              sx={{ mt: 0.25, bgcolor: '#FFFFFF', border: '1px solid #E2E8F0' }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
          <Box minWidth={0}>
            {eyebrow && (
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}
              >
                {eyebrow}
              </Typography>
            )}
            <Typography
              variant="h5"
              fontWeight={700}
              lineHeight={1.2}
              sx={{ wordBreak: 'break-word' }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary" marginTop={0.5}>
                {subtitle}
              </Typography>
            )}
            {children}
          </Box>
        </Stack>
        {actions && (
          <Stack
            direction="row"
            gap={1}
            flexWrap="wrap"
            alignItems="center"
            justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
            flexShrink={0}
          >
            {actions}
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}

export default PageHeader
